<template>
  <swiper :modules="[SwiperNavigation]" :navigation="{ nextEl: nextRef, prevEl: prevRef}" :slides-per-group="3"
          :slidesPerView="3"
          :space-between="20" resistance v-bind="$attrs">
    <slot name="swiper">
      <swiper-slide v-for="(item, index) in items" :key="`product-${index}`" class="bg-white rounded-lg">
        <slot :index="index" :item="item"/>
      </swiper-slide>
    </slot>
  </swiper>
  <div ref="prevRef"
       class="flex-center !top-0 !h-full !z-2 !m-0 swiper-button-prev flip-icon ltr:-left-3 rtl:left-auto rtl:-right-3">
    <div class="bg-white shadow-md text-secondary w-[24px] h-[24px] rounded-full flex-center">
      <van-icon name="arrow-left"/>
    </div>
  </div>
  <div ref="nextRef"
       class="flex-center !top-0 !h-full !z-2 !m-0 swiper-button-next flip-icon ltr:-right-3 rtl:right-auto rtl:-left-3">
    <div class="bg-white shadow-md text-secondary w-[24px] h-[24px] rounded-full flex-center">
      <van-icon name="arrow"/>
    </div>
  </div>
</template>

<script setup>
defineProps({
  items: {
    type: Array,
    default: () => []
  }
})

const nextRef = ref(null)
const prevRef = ref(null)
</script>

<style scoped>

</style>